import React, { useMemo, useRef } from 'react';
import SEO from '../components/SEO';
import HeroCarousel from '../components/HeroCarousel';
import PhotoSet from '../components/PhotoSet';
import Reveal from '../components/Reveal';
import { shuffleArray } from '../utils/shuffle';
import { GALLERIES, coverFirst, imagesFor } from '../utils/galleries';
import { personSchema, organizationSchema, websiteSchema } from '../utils/schema';
import content from '../content/home.json';

const altFor = (image, i) => image.caption || `Adventure and travel photography by Jonny Coe — image ${i + 1}`;

const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const Home = () => {
  const introRef = useRef(null);
  const slides = useMemo(
    () =>
      GALLERIES.map((gallery) => ({
        gallery,
        pool: coverFirst(shuffleArray(imagesFor(gallery.slug)), gallery.cover),
      })),
    []
  );
  const selected = useMemo(() => shuffleArray(imagesFor('home')), []);
  const intro = useMemo(() => shuffleArray(imagesFor('home')), []);

  return (
    <main className="home">
      <SEO content={content} jsonLd={[websiteSchema(), personSchema(), organizationSchema()]} />
      <HeroCarousel slides={slides} intro={intro} />

      <div className="scrollCue">
        <button
          type="button"
          className="scrollCue__button"
          aria-label="Scroll to content"
          onClick={() => introRef.current?.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth' })}
        >
          <svg width="14" height="8" viewBox="0 0 14 8" fill="none" stroke="currentColor" strokeWidth="1.2" aria-hidden="true">
            <polyline points="1,1 7,7 13,1" />
          </svg>
        </button>
      </div>

      <section className="intro" ref={introRef}>
        <Reveal as="h1" className="intro__title">
          {content.title}
        </Reveal>
        <Reveal as="p" className="intro__subtitle" delay={0.1}>
          {content.subtitle}
        </Reveal>
      </section>

      <div className="home__photos">
        <PhotoSet images={selected} title="Selected" label="Selected" altFor={altFor} />
      </div>
    </main>
  );
};

export default Home;
